import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import Snackbar from '@/models/snackbar.model'
import { ErrorResponse } from '@/interfaces/error-response.interface'

@Module
export default class SnackbarsStore extends VuexModule {
    snackbars: Snackbar[] = []

    @Mutation
    addMessage (newMessage: Snackbar) {
        this.snackbars.push(newMessage)
    }

    @Mutation
    reportError (newErrors: ErrorResponse) {
        const newMessage = new Snackbar('Error message not found :(', 'error')

        if (newErrors.message) {
            newMessage.message = newErrors.message
        }

        this.snackbars.push(newMessage)
    }

    @Mutation
    reportSuccess (newSuccess: string) {
        const newMessage = new Snackbar(newSuccess, 'success')
        this.snackbars.push(newMessage)
    }

    @Mutation
    removeLastMessage () {
        this.snackbars.shift()
    }
}
